import { faPhone } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'
import React from 'react'

import ActionButton from './ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const ContactButton: FC<Props> = ({ onClick, disabled = false }) => (
  <ActionButton label="Contact" icon={faPhone} onClick={onClick} disabled={disabled} />
)

export default ContactButton
